import React from 'react';
import { Avatar } from '@mui/material';
import AudioMiniPreview from '@dyl/components/AudioMiniPreview';
import ImageMiniPreview from '@dyl/components/ImageMiniPreview';

/**
 * @param {Object} props
 * @param {File} props.file
 */
export default function FilePreview({ file, ...other }) {
    if (file.type.includes('audio')) {
        return <AudioMiniPreview blob={file} {...other} />;
    }
    else if (file.type.includes('image')) {
        return <ImageMiniPreview blob={file} alt={file.name} {...other} />
    }
    else {
        return <Avatar variant='square' style={{ width: 48, height: 48 }} {...other}>?</Avatar>
    }
}

